import React from 'react';

const Header = () => {
  return (
    <main>
      <section className='py-5 text-center container'>
        <div className='row py-lg-5'>
          <div className='col-lg-6 col-md-8 mx-auto'>
            <h1 className='display-3'>Game of Codes</h1>
            <p className='lead' style={{ fontSize: '1.1rem' }}>
              All Competitive Programming contests at one place.
            </p>
            <p>
              <a href='#contests' className='btn btn-primary my-2 mr-4'>
                Start Exploring
              </a>
            </p>
            <p></p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Header;
